import { Component, OnInit } from '@angular/core';
import { Message } from 'src/app/models/message';
import { CountT3, ReportT3 } from 'src/app/models/obs/report';
import { Tier1 } from 'src/app/models/obs/tier1';
import { AccessService } from 'src/app/services/access.service';
import { ReportService } from 'src/app/services/obs/report.service';
import { Tier1Service } from 'src/app/services/obs/tier1.service';
import { PersonService } from 'src/app/services/person.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { UserLogService } from 'src/app/services/user-log.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import autoTable from 'jspdf-autotable';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-admreport',
  templateUrl: './admreport.component.html',
  styleUrls: ['./admreport.component.scss']
})
export class AdmreportComponent implements OnInit {

  msg: Message;
  tier1: Tier1[] = [];
  reportsTier3: ReportT3[] = [];

  numTN: CountT3[] = [];
  numTG: CountT3[] = [];
  numTT: CountT3[] = [];
  numR: CountT3[] = [];
  numM: CountT3[] = [];
  numO: CountT3[] = [];
  numEC: CountT3[] = [];
  numEL: CountT3[] = [];
  numS: CountT3[] = [];
  arrayTN: ReportT3[];
  arrayTG: ReportT3[];
  arrayTT: ReportT3[];
  arrayM: ReportT3[];
  arrayR: ReportT3[];
  arrayO: ReportT3[];
  arrayEC: ReportT3[];
  arrayEL: ReportT3[];
  arrayS: ReportT3[];
  idTN: number = 5;
  idTG: number = 11;
  idTT: number = 12;
  idM: number = 7;
  idR: number = 6;
  idO: number = 4;
  idEC: number = 14;
  idEL: number = 9;
  idS: number = 8;

  //bandera que identifica al modulo
  accessMP = {}
  /* Permite determinar si el usuario actual tiene permiso para el modulo */
  inf = {}

  constructor(
    private tier1Service: Tier1Service,
    private reportService: ReportService,
    private accesService: AccessService,
    private ts: TokenStorageService,
    private logService: UserLogService,
    private personsService: PersonService
  ) { }

  ngOnInit() {
    this.getTier1();
    this.getPermission();
    this.consult();
    this.getAllNamePerson();
  }

  getPermission() {
    this.inf['userId'] = this.ts.getUser().id;
    this.inf['accessId'] = 12;
    const data = this.inf;
    this.accesService.getPermissionUser(data).subscribe({
      next: res => { this.accessMP = res['result'] },
      error: err => { this.msg = err; }
    });
  }

  getTier1() {
    this.tier1Service.getAll().subscribe({
      next: res => {
        this.tier1 = res['data'].filter(item => item.ideventtype !== 9);
        this.getReportAllTier3(this.tier1);
        this.counterAllTier3(this.tier1);
      },
      error: err => { this.msg = err; }
    });
  }

  getReportAllTier3(tier1: Tier1[]) {
    tier1.forEach(async t1 => {
      const data = await this.getReportTier3(t1.id);
      if (data.length > 0) t1.report = data;
    });
  }

  counterAllTier3(tier1: Tier1[]) {
    tier1.forEach(async t1 => {
      const data = await this.countTier3(t1.id);
      if (data.length > 0) t1.count = data;
    });
  }

  async countTier3(id: number) {
    try {
      const res = await firstValueFrom(this.reportService.callTier3Counter(id));
      return res['data'];
    } catch (err) {
      this.msg = err;
      return [];
    }
  }

  async getReportTier3(id: number): Promise<ReportT3[]> {
    try {
      const res = await firstValueFrom(this.reportService.reportT3(id));
      return res['data'];
    } catch (err) {
      this.msg = err;
      return [];
    }
  }

  //lista de log 
  logFlag = 0;//determina si hay contenido en la respuesta
  listLog = {}//usamos para enviar la respuesta al bucle for 
  //variables de busqueda
  usuario: string = '';
  ficha: string = '';
  modulo: string = '';
  dataFilter = {}

  //consult responde a boton filtrar y  realiza la busqueda en bd
  consult() {

    this.dataFilter['nameUser'] = this.usuario;
    this.dataFilter['idtier3'] = this.ficha;
    this.dataFilter['nameComponent'] = this.modulo;
    const data = this.dataFilter;
    this.logService.showUserLogByFilter(data).subscribe({
      next: res => {
        if (Object.keys(res['data']).length > 0) {
          this.logFlag = 1;
          this.listLog = res['data'];
        } else {
          this.logFlag = 2;
          this.listLog = res['data'];
        }
      },
      error: err => { }
    })

  }

  //Conseguir nombres de usuarios combo-box
  result: any;
  users: any;
  getAllNamePerson() {
    this.personsService.getAll().subscribe({
      next: res => {
        this.result = res
        this.users = res['data'];
      },
      error: err => {
        this.msg = err;
      }
    });
  }

  //generamos el archivo pdf valido en  google chrome
  downloadPdf() {
    const doc = new jsPDF()
    autoTable(doc, { html: '#tableLog', styles: { fontSize: 9, halign: 'center' }, headStyles: { fillColor: [59, 105, 174] }, alternateRowStyles: { fillColor: [235, 240, 246] }, tableLineColor: [59, 105, 174], tableLineWidth: 0.1 });
    doc.save('log de cambios.pdf')

  }
}
